var map = {
	"./0.png": "ee4e",
	"./1.png": "d3e1",
	"./2.png": "076a",
	"./3.png": "997f",
	"./4.png": "2370",
	"./5.png": "10ae",
	"./6.png": "375f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "93a1";